import { render, staticRenderFns } from "./Expenditure.vue?vue&type=template&id=b58d118a&scoped=true&"
import script from "./Expenditure.vue?vue&type=script&lang=js&"
export * from "./Expenditure.vue?vue&type=script&lang=js&"
import style0 from "./Expenditure.vue?vue&type=style&index=0&id=b58d118a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58d118a",
  null
  
)

export default component.exports